/**
 * Returns a value indicating that the specified `ref` is out of the viewport in
 * a given direction +ve or -ve pixels. If the `ref` is within the viewport then
 * returns 0.
 *
 * @param {Node|ReactElement} ref Reference to a DOM Node or React Element.
 * @returns {Number|undefined} Number of pixels document.body.scrollTop must be modified by
 * @public
 */
export default function outOfViewport(ref) {
  const rect = ref.getBoundingClientRect();
  if (rect.top < 0) {
    return rect.top;
  }

  const height = window.innerHeight || document.documentElement.clientHeight;
  if (rect.bottom > height) {
    return rect.bottom - height;
  }

  return 0;
}
